import React, { useEffect, useState } from "react";
import Image from "../image/image.component";
import { ReactComponent as PlayIcon } from '../../icons/play.svg';
import { CMVideo, VideoModal } from "./youtube-embed.styles";
import { Modal } from "@mui/material";

const YoutubeEmbed = ({source, thumbnail, width, height, auctionID }) => {
  
  const [play, setPlay] = useState(false);
  const [newThumbnail, setNewThumbnail] = useState(thumbnail); 
  const [embedUrl, setEmbedUrl] = useState('');
  const apiURL = process.env.REACT_APP_PATH;

  function getVideoCover(file, seekTo = 0.0) {
    var tn = document.getElementById(`tn${auctionID}`);
    if (!tn) {
      console.error(`Element with id tn${auctionID} not found`);
      return;  
    }
  
    tn.style.display = "none";
    var canvas = document.getElementById(`canV${auctionID}`);
    if (!canvas) {
      console.error(`Element with id canV${auctionID} not found`);
      return;  
    }
  
    canvas.style.display = "block";
    var ctx = canvas.getContext("2d");
  
    var video = document.createElement("video");
    video.muted = true;

    if (!source) {
      console.error('Video source is undefined or invalid');
      return;
    }
    
    video.src = source;
  
    video.addEventListener('loadeddata', function() {
      video.currentTime = seekTo;  
      video.play().then(() => {
        setTimeout(() => {
          update();
          video.pause();
        }, 100);
      }).catch(error => {
        console.error('Error playing video:', error);  
      });
    });
  
    function update() {
      if (video.readyState >= 2) { 
        var tmpHeight = tn.getAttribute("height");
        var tmpWidth = width ? width : tmpHeight * (16 / 9);
        ctx.drawImage(video, 0, 0, tmpWidth, height);
      }
      requestAnimationFrame(update);
    }
  }

function isValidUrl(url) {
  try {
    new URL(url);
    return true;
  } catch (error) {
    return false;
  }
}

function transformVideoUrl(source) {
  if (!source || !isValidUrl(source)) {
    console.error("URL is empty or null.");
    return source; 
  }
  const url = new URL(source);
  const hostname = url.hostname;
  let embedUrl = source;

  switch(hostname) {
    case "www.youtube.com":
      const youtubeId = url.searchParams.get("v");
      embedUrl = `https://www.youtube.com/embed/${youtubeId}`;
      break;
    case "youtu.be":
        const youtubeShortId = url.pathname.split("/").pop();
        embedUrl = `https://www.youtube.com/embed/${youtubeShortId}`;
        break;
    case "www.dailymotion.com":
      const dailymotionId = url.pathname.split("/").pop();
      embedUrl = `https://www.dailymotion.com/embed/video/${dailymotionId}`;
      break;
    case "vimeo.com":
      const vimeoId = url.pathname.split("/").pop();
      embedUrl = `https://player.vimeo.com/video/${vimeoId}`;
      break;
    case "www.twitch.tv":
      const twitchId = url.pathname.split("/").pop();
      embedUrl = `https://player.twitch.tv/?channel=${twitchId}`;
      break;
    case "d.tube":
      const dtubeId = url.pathname.split("/").pop();
      embedUrl = `https://emb.d.tube/#!/${dtubeId}`;
      break;
    case "utreon.com":
      const utreonId = url.pathname.split("/").pop();
      embedUrl = `https://utreon.com/embed/${utreonId}`;
      break;
    default:
      embedUrl = source;
  }

  return embedUrl;
}

function getVideoThumbnailUrl(source) {
  if (!source || !isValidUrl(source)) {
    console.error("Source is empty or null.");
    return thumbnail; 
  }

  const url = new URL(source);
  const hostname = url.hostname;

  /*switch(hostname) {
    case "www.youtube.com":
      if (source.indexOf("youtube.com/embed") !== -1) {
        const baseSource = source.split("?")[0];
        const id = baseSource.split("/").pop();
        return `https://img.youtube.com/vi/${id}/0.jpg`;
      } else if (source.indexOf("youtube.com/watch") !== -1) {
        const videoId = url.searchParams.get("v");
        return `https://img.youtube.com/vi/${videoId}/0.jpg`;
      }
      break;
    case "youtu.be":
        const youtubeShortId = url.pathname.split("/").pop();
        return `https://img.youtube.com/vi/${youtubeShortId}/0.jpg`;
        break;
    case "www.dailymotion.com":
      const dailymotionId = url.pathname.split("/").pop();
      return `https://www.dailymotion.com/thumbnail/video/${dailymotionId}`;
    case "vimeo.com":
    const vimeoId = url.pathname.split("/").pop();
    return `https://vumbnail.com/${vimeoId}`;
    default:
      if (source.indexOf(`${apiURL}/Portals/0/Uploads/`) !== -1) {
        getVideoCover(source, 1.5);
      } 
      return thumbnail; 
  }*/
      return thumbnail;
    }

const videoToImage = () => {
  if (!source || !isValidUrl(source)) {
    console.error("Source is null or undefined.");
    return;
  }
  const newThumbnailUrl = getVideoThumbnailUrl(source);
  setNewThumbnail(newThumbnailUrl);
}

const createIframe = () => {
  setPlay(true);
}

useEffect(() => {
  videoToImage();
}, [])

useEffect(() => {
  const newEmbedUrl = transformVideoUrl(source);
  setEmbedUrl(newEmbedUrl);
}, [source])

return (
 <>
  <CMVideo width={width || '100%'} height={height || 'auto'}  onClick={createIframe}>
    <div style={{position: 'relative', width:width}}>
      <canvas id={`canV${auctionID}`} width={width || (height * 16/9)} height={height || 'auto'} style={{overflow: "hidden", display: "none", objectFit: 'cover', borderRadius: '12px'}}></canvas>
      <Image id={`tn${auctionID}`} src={newThumbnail} width={width || '100%'} height={height || 'auto'} style={{objectFit: 'cover', borderRadius: '12px'}}/>
      <div style={{position: 'absolute', top: 'calc(50% - 14px)', left: 'calc(50% - 14px)'}}>
        <PlayIcon width={28} height={28} />
      </div>
    </div>
  </CMVideo>
  <Modal open={play} onClose={() => setPlay(false)}>
  <VideoModal>
    {play && embedUrl ? (
      <iframe
        width='100%'
        height='100%'
        src={`${embedUrl}?rel=0&autoplay=1`}
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        title='Embedded Video'
      />
    ) : (
      <div>Error al cargar el video</div>  
    )}
  </VideoModal>
</Modal>
 </>
);
};

export default YoutubeEmbed;
